import { takeLatest } from 'redux-saga/effects';
import * as actionTypesNR01 from '../actions/actionTypesNR01';
import {
  createNR01StockGruppeSaga,
  deleteNR01StockGruppeSaga,
  fetchNR01StockGruppeSaga,
  updateNR01StockGruppeSaga,
} from './NR01.saga';

export function* watchNR01Saga() {
  yield takeLatest(actionTypesNR01.NR01_STOCKGRUPPE_GET, fetchNR01StockGruppeSaga);
  yield takeLatest(actionTypesNR01.NR01_STOCKGRUPPE_CREATE, createNR01StockGruppeSaga);
  yield takeLatest(actionTypesNR01.NR01_STOCKGRUPPE_DELETE, deleteNR01StockGruppeSaga);
  yield takeLatest(actionTypesNR01.NR01_STOCKGRUPPE_UPDATE, updateNR01StockGruppeSaga);
}
